import React from 'react'
import UserProfileModel from '../models/user-models/UserProfileModel'
import { FirebaseService, FirebaseConfigKey } from './FirebaseService'
import { BillingPeriod } from '../models/insurance-models/InsuranceBillingPeriodModel'
import { liabilityLimitPretty, getTotalHullValue, isUK } from './utils'
import { COUNTRIES } from '../Constants'
import { SessionService } from './SessionService'
import BrokerConfigService from './BrokerConfigService'
import vehiclesApi from '../api/vehicles.api'
import operatorsApi from '../api/operators.api'

class ViolationsService {
  isUserProfileOK(userProfile: UserProfileModel) {
    return userProfile.firstName && userProfile.lastName && userProfile.address1
  }

  async isVehiclePageOk() {
    let res = await vehiclesApi.motorcyclesDetailsNext()
    return res
  }

  async isOperatorsPageOk() {
    let res = await operatorsApi.operatorsDetailsNext()
    return res
  }

  isCreditCardOK(userProfile) {
    return userProfile.hasCreditCard
  }

  checkOperatorsViolations(operators: any[]) {
    return (
      FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.US ||
      FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.CANADA ||
      (FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.UK && operators.length > 0)
    )
  }
}

export default new ViolationsService()
